import React, { useEffect, useState } from 'react'
import Floatingbutton from './Floatingbutton'
import Addusersmodal from '../SuperAdminmodal/Addusersmodal'
import Conformationdeleteusermodal from '../SuperAdminmodal/Conformationdeleteusermodal'
import config from '../../config'
import axios from 'axios'
import { toast } from 'react-toastify'
import { useMemo } from 'react'

const Allusers = () => {
  const [showModal, setShowModal] = useState(false)
  const [selectId, setSelectId] = useState(null)
  const [deleteId, setDeleteId] = useState(null)
  const [showConfirmModal, setShowConfirmModal] = useState(false)
  const [users, setUsers] = useState([])
  const [inputData, setInputData] = React.useState([])
  const [rolls, setRolls] = React.useState([])

  const [pagination, setPagination] = useState({
    totalRecords: 0,
    totalPages: 0,
    currentPage: 0,
    limit: 0,
    hasNextPage: false,
    hasPrevPage: false
  })

  useEffect(() => {
    if (showModal) {
      fetchinputs()
    }
  }, [showModal])

  useEffect(() => {
    peginationdata()
  }, [pagination.currentPage, pagination.limit])

  useEffect(() => {
    fetchinputs()
  }, [])

  useEffect(() => {
    fetchrolls()
  }, [])

  useEffect(() => {
    if (showModal) {
      fetchrolls()
    }
  }, [showModal])

  const fetchinputs = async () => {
    const token = localStorage.getItem('token')
    try {
      const res = await axios.get(
        `${config.apiUrl}/projects/projects-with-wings`,
        {
          headers: { Authorization: token }
        }
      )
      console.log('FULL API RESPONSE:', res.data)
      const normalized = (res.data || []).flatMap(project =>
        (project.Wings || []).map(wing => ({
          projectId: project.ID,
          projectName: project.Name.trim(),
          wingId: wing.ID,
          wingName: wing.Name
        }))
      )
      setInputData(normalized)
    } catch (err) {
      console.error(err)
      toast.error('Failed to fetch posts')
    }
  }

  const fetchrolls = async () => {
    const token = localStorage.getItem('token')
    try {
      const res = await axios.get(`${config.apiUrl}/roles/list`, {
        headers: { Authorization: token }
      })

      console.log('ROLES ARRAY:', res.data.data)
      const normalized = (res.data.data || []).map(roll => ({
        rollId: roll.ID,
        rollName: roll.Name
      }))

      setRolls(normalized)
    } catch (err) {
      console.error(err)
      // toast.error('Failed to fetch posts')
    }
  }

  const peginationdata = async () => {
    const token = localStorage.getItem('token')
    try {
      const res = await axios.get(
        `${config.apiUrl}/user/getUsers?page=${pagination.currentPage}&limit=${pagination.limit}`,
        { headers: { Authorization: token } }
      )
      const usersData = res.data.data ?? []
      setUsers(
        usersData
          .map(user => ({
            id: user.ID,
            username: user.Name?.trim() || '',
            mobileno: user.MobileNo || '',
            email: user.EmailID || '',
            roleId: user.RoleID ?? null,
            ProjectID: user.ProjectID ?? null,
            Wing: user.Wing ?? null,
            RoomNo: user.RoomNo ?? null,
            deletedOn: user.DeletedOn
          }))
          .sort((a, b) => b.id - a.id)
      )

      setPagination(prev => ({
        ...prev,
        totalRecords: res.data.pagination?.totalRecords ?? 0,
        totalPages: res.data.pagination?.totalPages ?? 0,
        currentPage: res.data.pagination?.currentPage ?? prev.currentPage,
        limit: res.data.pagination?.limit ?? prev.limit,
        hasNextPage: res.data.pagination?.hasNextPage ?? false,
        hasPrevPage: res.data.pagination?.hasPrevPage ?? false
      }))
    } catch (err) {
      toast.error('Failed to load users')
    }
  }

  const createusers = async payload => {
    const token = localStorage.getItem('token')
    try {
      const res = await axios.post(`${config.apiUrl}/user/create`, payload, {
        headers: { Authorization: token }
      })
      const user = res.data.data
      setUsers(prev =>
        [
          {
            id: user.ID,
            username: user.Name?.trim() || '',
            mobileno: user.MobileNo || '',
            email: user.EmailID || '',
            roleId: user.RoleID ?? null,
            ProjectID: user.ProjectID ?? null,
            Wing: user.Wing ?? null,
            RoomNo: user.RoomNo ?? null
          },
          ...prev
        ].sort((a, b) => b.id - a.id)
      )
      toast.success('User Created Successfully')
      setShowModal(false)
    } catch (e) {
      console.log('Error creating user', e)
      toast.error('User Already Created')
    }
  }

  const handleConfirmDelete = async () => {
    if (!deleteId) return

    const token = localStorage.getItem('token')
    try {
      await axios.delete(`${config.apiUrl}/user/delete/${deleteId}`, {
        headers: {
          Authorization: token,
          'Content-Type': 'application/json'
        }
      })

      await peginationdata()

      setUsers(prev => prev.filter(user => user.id !== deleteId))

      toast.success('User deleted successfully!')
      setShowConfirmModal(false)
      setDeleteId(null)
    } catch (e) {
      console.error(e)
      toast.error('Failed to delete user')
    }
  }

  const goPrevious = () => {
    if (pagination.hasPrevPage) {
      setPagination(prev => ({ ...prev, currentPage: prev.currentPage - 1 }))
    }
  }

  const goNext = () => {
    if (pagination.hasNextPage) {
      setPagination(prev => ({ ...prev, currentPage: prev.currentPage + 1 }))
    }
  }

  const handleRowsPerPageChange = e => {
    setPagination(prev => ({
      ...prev,
      limit: parseInt(e.target.value),
      currentPage: 1
    }))
  }

  const startRow = (pagination.currentPage - 1) * pagination.limit + 1
  const endRow = Math.min(
    pagination.currentPage * pagination.limit,
    pagination.totalRecords
  )

  const projectMap = useMemo(() => {
    const map = {}
    inputData.forEach(item => {
      if (!map[item.projectId]) {
        map[item.projectId] = item.projectName
      }
    })
    return map
  })
  console.log(projectMap)

  const RollsName = useMemo(() => {
    const rollmap = {}
    rolls.forEach(item => {
      if (!rollmap[item.rollId]) {
        rollmap[item.rollId] = item.rollName
      }
    })
    return rollmap
  })
  console.log(RollsName)

  const handlemodalOpen = id => {
    setSelectId(id)
    setShowModal(true)
  }

  const handleDeleteModal = id => {
    setDeleteId(id)
    setShowConfirmModal(true)
  }

  const handleCancelDelete = () => {
    setShowConfirmModal(false)
    setDeleteId(null)
  }

  return (
    <div id="app-Capsule">
      <div className="pt-4">
        <div className="table-responsive-sm pt-5">
          <table className="table table-bordered">
            <thead>
              <tr>
                <th className="text-center text-bold fs-6">Sr.No</th>
                <th className="text-center text-bold fs-6">Name</th>
                <th className="text-center text-bold fs-6">Mobile No</th>
                <th className="text-center text-bold fs-6">Email ID</th>
                <th className="text-center fs-6 text-bold">Project ID</th>
                <th className="text-center fs-6 text-bold">Roll ID</th>
                <th className="text-center fs-6 text-bold">Wing</th>
                <th className="text-center fs-6 text-bold">Room No</th>
                <th className="text-center fs-6 text-bold">Delete User</th>
              </tr>
            </thead>

            <tbody>
              {users.map((user, index) => (
                <tr
                  key={user.id}
                  className="text-center"
                  style={{
                    cursor: user.deletedOn ? 'not-allowed' : 'pointer',
                    // color: user.deletedOn ? 'red' : 'inherit',
                    background: user.deletedOn ? 'rgb(220 220 220)' : 'inherit'
                  }}
                >
                  <th scope="row">{startRow + index}</th>
                  <td className='text-bold'>{user.username}</td>
                  <td className='text-bold'>{user.mobileno}</td>
                  <td className='text-bold'>{user.email}</td>
                  <th>{projectMap[user.ProjectID] || '—'}</th>
                  <th>{RollsName[user.roleId] || '—'}</th>
                  <th>{user.Wing}</th>
                  <th>{user.RoomNo}</th>
                  <th>
                    <div
                      className="rounded-circle"
                      style={{
                        backgroundColor: 'red',
                        width: '30px',
                        height: '30px',
                        boxShadow: '0 2px 6px rgba(0,0,0,0.3)',
                        cursor: user.deletedOn ? 'not-allowed' : 'pointer',
                        zIndex: 10,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        margin: 'auto',
                        filter: user.deletedOn ? 'blur(2px)' : 'none',
                        opacity: user.deletedOn ? 0.5 : 1
                      }}
                      onClick={() => {
                        if (!user.deletedOn) {
                          handleDeleteModal(user.id)
                        }
                      }}
                    >
                      <ion-icon
                        name="trash"
                        style={{ fontSize: '15px', color: 'white' }}
                      />
                    </div>
                  </th>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div className="d-flex align-items-center justify-content-center"style={{
        paddingBottom: "5rem",
        paddingTop: "1rem"
      }}>
        <div className="d-flex align-items-center gap-3 flex-wrap">
          <button
            className="btn btn-outline-secondary btn-sm"
            onClick={goPrevious}
            disabled={!pagination.hasPrevPage}
          >
            &lt;
          </button>

          <button
            className="btn btn-outline-secondary btn-sm"
            onClick={goNext}
            disabled={!pagination.hasNextPage}
          >
            &gt;
          </button>

          <span className="fw-medium mx-2">
            Page <strong>{pagination.currentPage}</strong> of{' '}
            <strong>{pagination.totalPages}</strong>
          </span>

          <div className="d-flex align-items-center gap-2">
            <span>Show</span>
            <select
              className="form-select form-select-sm"
              value={pagination.limit}
              onChange={handleRowsPerPageChange}
              style={{ width: '80px' }}
            >
              <option value="5">5</option>
              <option value="10">10</option>
              <option value="15">15</option>
              <option value="20">20</option>
              <option value="30">30</option>
            </select>
          </div>
        </div>

        {/* <div className="text-muted small" style={{ paddingLeft: '12px' }}>
          Showing <strong>{startRow}</strong> to <strong>{endRow}</strong> of{' '}
          <strong>{pagination.totalRecords}</strong> Rows
        </div> */}
      </div>

      <Floatingbutton onOpen={() => setShowModal(true)} />
      <Addusersmodal
        show={showModal}
        userId={selectId}
        createusers={createusers}
        fetchinputs={fetchinputs}
        inputData={inputData}
        rolls={rolls}
        onClose={() => setShowModal(false)}
      />
      <Conformationdeleteusermodal
        show={showConfirmModal}
        onClose={handleCancelDelete}
        onConfirm={handleConfirmDelete}
      />
    </div>
  )
}

export default Allusers
